import React, { useState, useEffect } from "react";

import AdeptaSororitasIcon from '../img/wh40k/adepta_sororitas.webp';
import AdeptusCustodes from '../img/wh40k/adeptus_custodes.webp';
import AdeptusMechanicusIcon from '../img/wh40k/adeptus_mechanicus.webp'; 
import AeldariIcon from '../img/wh40k/aeldari.webp';
import AstraMilitarumIcon from '../img/wh40k/astra_militarum.webp';
import BlackTemplarsIcon from '../img/wh40k/black_templars.webp';
import BloodAngelsIcon from '../img/wh40k/blood_angels.webp';
import ChaosKnightsIcon from '../img/wh40k/chaos_knights.webp';
import ChaosSpaceMarinesIcon from '../img/wh40k/chaos_space_marines.webp';
import DeathGuardIcon from '../img/wh40k/death_guard.webp';  
import DrukhariIcon from '../img/wh40k/drukhari.webp';
import GreyKnightsIcon from '../img/wh40k/grey_knights.webp';
import ImperialKnightsIcon from '../img/wh40k/imperial_knights.webp';
import NecronsIcon from '../img/wh40k/necrons.webp';
import OrksIcon from '../img/wh40k/orks.webp';  
import SpaceWolvesIcon from '../img/wh40k/space_wolves.webp'; 
import SpaceMarinesIcon from '../img/wh40k/space_marines.webp';
import TauEmpireIcon from '../img/wh40k/tau_empire.webp';
import TyranidsIcon from '../img/wh40k/tyranids.webp';
import DefaultIcon from '../img/wh40k/default.webp';

const armyIcons = {
  adepta_sororitas: AdeptaSororitasIcon,
  adeptus_custodes: AdeptusCustodes,
  adeptus_mechanicus: AdeptusMechanicusIcon,
  aeldari: AeldariIcon,
  astra_militarum: AstraMilitarumIcon,
  black_templars: BlackTemplarsIcon,
  blood_angels: BloodAngelsIcon,
  chaos_knights: ChaosKnightsIcon,
  chaos_space_marines: ChaosSpaceMarinesIcon,
  drukhari: DrukhariIcon,
  death_guard: DeathGuardIcon,
  grey_knights: GreyKnightsIcon,
  imperial_knights: ImperialKnightsIcon,
  necrons: NecronsIcon,
  orks: OrksIcon,
  space_wolves: SpaceWolvesIcon,
  space_marines: SpaceMarinesIcon,
  tau_empire: TauEmpireIcon,
  tyranids: TyranidsIcon,
  default: DefaultIcon
};

export const getArmyIcon = (armyName) => {
  const formattedName = armyName ? armyName.toLowerCase().replace(/\s+/g, "_") : 'default';
  console.log(armyIcons[formattedName]);
  return armyIcons[formattedName] || DefaultIcon;
};

